export default __webpack_public_path__ + "static/media/PAFI_Annual Report 2021.7e3c8734.pdf";